import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from '@angular/core';
import {PlaningArea} from '../../../../api/src/template/template.model';
import {TableColumns} from '@inspark/inspark-components';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {TimerangeModel} from '../../../../api/src/timerange/timerange.model';


const scheduletypeStrategy = (pa: PlaningArea | null): 'DAILY' | 'DAYS_OF_WEEK' | 'YEAR_DAY' => {

  const checkDays = (...days: string[]): boolean => {
    let result = false;
    days.forEach(day => result = result || pa[day]);
    return result;
  };
  const hasDays = checkDays('monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday');
  const hasIntervals = pa.planningdates.length > 0;
  pa.timeranges.forEach(tr => tr.bindingtype = 'LEFT_BORDER');
  switch (true) {
    case !hasDays && !hasIntervals:
      // pa.timeranges.forEach(tr => tr.bindingtype = 'LEFT_BORDER');
      return 'DAILY';
      break;
    case hasDays && !hasIntervals:
      // pa.timeranges.forEach(tr => tr.bindingtype = 'LEFT_BORDER');
      return 'DAYS_OF_WEEK';
      break;
    case !hasDays && hasIntervals:
      // pa.timeranges.forEach(tr => tr.bindingtype = 'LEFT_BORDER');
      return 'YEAR_DAY';
      break;
  }
  return 'DAILY';
};

const EMPTY_EDIT = {key: '', id: ''};

@Component({
    selector: 'app-localtime-schedule-view',
    templateUrl: './localtime-schedule-view.component.html',
    styleUrls: ['./localtime-schedule-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LocaltimeScheduleViewComponent implements OnInit, OnChanges {
  @Input() planningareas: PlaningArea[];
  @Input() configPrefix: string = '';
  @Input() timeRanges: TimerangeModel[] = [];
  @Input() editMode: 'default' | 'onOrOff' = 'default';

  @Output() addPlaningArea = new EventEmitter<boolean>();
  @Output() removePlaningArea = new EventEmitter<number>();
  @Output() addPlaningDateRange = new EventEmitter<number>();
  @Output() removePlaningDateRange = new EventEmitter<{ paIndex: number, pdIndex: number }>();
  @Output() changeDays = new EventEmitter();
  @Output() updateTimerange = new EventEmitter();
  @Output() updateOnOrOff = new EventEmitter();
  @Output() validationError = new EventEmitter<string>();
  @ViewChild('daysTooltipHandler', {static: false}) daysTooltip: NgbTooltip;

  public items: any[] = [];
  public tableColumns: TableColumns[];
  public editField = EMPTY_EDIT;

  constructor() {
  }

  ngOnInit() {
    this.tableColumns = [{
      label: 'On time',
      field: 'leftbound',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Off time',
      field: 'rightbound',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Days of week',
      field: 'planingdates',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Period on (min)',
      field: 'activesubrange',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Period off (min)',
      field: 'passivesubrange',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Intervals',
      field: 'intervals',
      width: '',
      isHidden: false,
      size: '50px'
    }, {
      label: 'Repeat',
      field: 'repeat',
      width: '',
      isHidden: false,
      size: '50px'
    }];

    if (this.editMode === 'onOrOff') {
      this.tableColumns.push({
          label: 'OnValue',
          field: 'onvalue',
          width: '',
          isHidden: false,
          size: '50px'
        });
      this.tableColumns.push({
        label: 'OffValue',
        field: 'offvalue',
        width: '',
        isHidden: false,
        size: '50px'
      });
    }

    if (this.editMode === 'default') {
      this.tableColumns.push({
        label: '',
        field: '',
        width: '50px',
        isHidden: false,
        size: '50px'
      });
    }

    // "leftbound": -130, "rightbound": 160, "bindingtype": "BOTH_BORDERS", "activesubrange": 0, "passivesubrange": 0


  }

  ngOnChanges(changes) {
    const objectPlaningareaes = (pa, index): Record<string, any> => {
      // timerange всегда один или его нет
      pa.scheduletype = scheduletypeStrategy(pa);
      const result = {
        index, ...pa.timeranges[0], ...pa,
        planingdates: {
          monday: pa.monday,
          tuesday: pa.tuesday,
          wednesday: pa.wednesday,
          thursday: pa.thursday,
          friday: pa.friday,
          saturday: pa.saturday,
          sunday: pa.sunday
        },
        intervals: pa.planningdates,
        repeat: pa.planningdates
      };
      if (this.editMode === 'onOrOff') {
        const timerange = this.timeRanges.find(tr => {
          if (pa.timeranges && pa.timeranges.length > 0) {
            return tr.timeRange.id === pa.timeranges[0].id;
          }
          return false;
        });
        result['onvalue'] = timerange ? timerange.valueOn : undefined;
        result['offvalue'] = timerange ? timerange.valueOff : undefined;
      }
      return result;
    };
    this.items = [];
    this.planningareas.forEach( (_pa, index) => {
      if (['DAYS_OF_WEEK', 'DAILY', 'YEAR_DAY'].includes(_pa.scheduletype)) {
        this.items.push(objectPlaningareaes(_pa, index))
      }
    });
  }

  updateDay(index, object: Record<string, boolean>): void {
    const row = this.items.find(item => item.index === index);
    if (row) {
      row.planingdates = {...row.planingdates, ...object};
      this.changeDays.emit({index, planingdates: row.planingdates});
    }

  }

  updateText(index, field): void {
    const row = this.items.find(item => item.index === index);
    if (row) {
      let value = row[field];
      row[field] = value;
    }
    this.updateRow(index, field);
  }

  updateNumber(index, field): void {
    const row = this.items.find(item => item.index === index);
    if (row) {
      let value = parseInt(row[field], 10);
      if (isNaN(value)) {
        value = 0;
      }
      row[field] = value;
    }
    this.updateRow(index, field);
  }

  updateRow(index, field, value?): void {
    this.editField = EMPTY_EDIT;
    const row = this.items.find(item => item.index === index);
    const pa = this.planningareas[index];
    if (row && pa) {
      if (['leftbound', 'rightbound', 'bindingtype', 'activesubrange', 'passivesubrange'].includes(field)) {
        const timeranges = pa.timeranges[0];
        timeranges[field] = value === undefined ? row[field] : value;
        this.updateTimerange.emit({index, timeranges});
        return;
      }

      if (['onvalue', 'offvalue'].includes(field)) {
        const timeranges = pa.timeranges[0];
        timeranges[field] = value === undefined ? row[field] : value;
        this.updateOnOrOff.emit({index, timeranges});
        return;
      }
    }
  }

  days(days: { [key: string]: boolean }): string[] {
    const weekdays: { [key: string]: string } = {
      monday: 'Пн.',
      tuesday: 'Вт.',
      wednesday: 'Ср.',
      thursday: 'Чт.',
      friday: 'Пт.',
      saturday: 'Сб.',
      sunday: 'Вс.'
    };
    ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
    return Object.entries(days).filter(v => v[1]).map(v => {
      if (typeof v[0] === 'string') {
        return weekdays[v[0]] || v[0];
      }
      return '';
    });
  }

  removePlaningDate(paIndex: number, pdIndex: number): void {
    this.removePlaningDateRange.emit({paIndex, pdIndex});
  }

  delete(id: number): void {
    this.removePlaningArea.emit(id);
  }

  addInterval(id: number): void {
    this.addPlaningDateRange.emit(id);
  }

  add(): void {
    this.addPlaningArea.emit(true);
  }

  edit(id, key) {
    if (this.editMode === 'onOrOff') {
      if (['onvalue', 'offvalue'].includes(key)) {
        this.editField = {id, key};
      }
      return;
    }
    this.editField = {id, key};
  }

}

